import { Button, Modal } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactTable } from '@components';
import TransferHedge from './TransferHedge';
import { MRT_ToggleGlobalFilterButton } from 'material-react-table';

const dummyData = [
    {
        uuid: '1',
        portfolio: { name: 'Portfolio 1' },
        reference: 'Ref 1',
        transaction_type: 'Type 1',
        trade_date_str: '2023-01-01',
        delivery_period_sym: 'MWh',
        delivery_period_year: 2023,
        delivery_period_month: 1,
        start_date_str: '2023-01-01',
        end_date_str: '2023-01-31',
        volume: 1000
    },
    {
        uuid: '2',
        portfolio: { name: 'Portfolio 2' },
        reference: 'Ref 2',
        transaction_type: 'Type 2',
        trade_date_str: '2023-02-01',
        delivery_period_sym: 'MWh',
        delivery_period_year: 2023,
        delivery_period_month: 2,
        start_date_str: '2023-02-01',
        end_date_str: '2023-02-28',
        volume: 2000
    }
];

const HedgeTransfer = () => {
    const { pendingHedges } = useSelector((state) => state.hedges);

    const [selectedRow, setSelectedRow] = useState(null);

    // create hedge transfer modal
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = (hedge) => {
        setOpenModal(true);
        setSelectedRow(hedge);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const columns = useMemo(
        () => [
            {
                header: 'UUID',
                id: 'uuid',
                accessorFn: ({ uuid }) => uuid || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Portfolio',
                id: 'portfolio',
                Cell: ({ row }) => <>{row?.original?.portfolio?.name}</>
            },
            {
                header: 'Reference',
                id: 'reference',
                accessorFn: ({ reference }) => reference || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 100
            },
            {
                header: 'Type',
                id: 'transaction_type',
                accessorFn: ({ transaction_type }) => transaction_type || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 100
            },
            {
                header: 'Trade Date',
                id: 'trade_date_str',
                accessorFn: ({ trade_date_str }) => trade_date_str || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 100
            },
            {
                header: 'Contract',
                id: 'contract',
                Cell: ({ row }) =>
                    row?.original?.delivery_period_sym +
                    ' ' +
                    row?.original?.delivery_period_year +
                    ' ' +
                    row?.original?.delivery_period_month,
                size: 100
            },
            {
                header: 'Start Date',
                id: 'start_date_str',
                accessorFn: ({ start_date_str }) => start_date_str || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 100
            },
            {
                header: 'End Date',
                id: 'end_date_str',
                accessorFn: ({ end_date_str }) => end_date_str || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 100
            },
            {
                header: 'Volume [MWh]',
                id: 'volume',
                accessorFn: ({ volume }) =>
                    volume.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') ||
                    '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 100
            }
        ],
        []
    );

    const actionsMenu = useMemo(
        () =>
            ({ row }) =>
                [
                    // <MenuItem key="tranfer" onClick={() => handleOpenModal(row.original)}>
                    //     <MoveUpIcon sx={{ pr: '10px' }} /> Transfer
                    // </MenuItem>,
                    <Button
                        variant="outlined"
                        color="primary"
                        sx={{
                            p: 0,
                            m: 0,
                            px: '4px',
                            borderColor: '1px solid #27A9FF',
                            color: '#27A9FF',
                            fontSize: '13px',
                            '&:hover': {
                                borderColor: '1px solid #27A9FF',
                                color: 'white',
                                backgroundColor: '#27A9FF'
                            }
                        }}
                        disabled={row?.original?.bid > row?.original?.ask}
                        onClick={() => handleOpenModal(row.original)}
                    >
                        Transfer
                    </Button>
                ],
        []
    );

    return (
        <>
            <Modal open={openModal} onClose={handleCloseModal}>
                <TransferHedge
                    handleClose={handleCloseModal}
                    hedge={selectedRow}
                />
            </Modal>
            <ReactTable
                headerText={'Pending Hedges Transaction'}
                columns={columns}
                data={dummyData || []}
                actions={actionsMenu}
                renderToolbarInternalActions={({ table }) => (
                    <div onMouseDown={(e) => e.stopPropagation()}>
                        <MRT_ToggleGlobalFilterButton table={table} />
                    </div>
                )}
            />
        </>
    );
};

export default HedgeTransfer;
